import React from 'react';

const CompetitiveAdvantage = () => {
  return (
    <div className="space-y-8">
      <div className="bg-white p-8 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold text-primary mb-6">Competitive Advantage</h3>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h4 className="font-semibold text-primary mb-4">First Mover Advantage</h4>
            <p className="text-gray-700 mb-4">
              Senti's foundational AI model for biosignal processing is a world-first. While competitors employ
              deep learning and generative models for specific biosignal applications, these are not 'large'
              models and cannot be generalized across applications.
            </p>
            <p className="text-gray-700">
              Our early position in this space creates significant advantages, similar to how OpenAI captured
              75% of the LLM market through early innovation in large language models.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-primary mb-4">Proprietary Dataset</h4>
            <p className="text-gray-700 mb-4">
              Our LBM is trained on a proprietary dataset of over 2TB of biosignal data—an unprecedented scale
              in the field of biosignals. For context, the largest publicly-available ECG dataset currently sits at 3GB,
              and EEG dataset at 8.1GB.
            </p>
            <p className="text-gray-700">
              This data advantage creates a significant barrier to entry for competitors, as training a similar
              model would require years of data collection and annotation.
            </p>
          </div>
        </div>

        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
          <div>
            <h4 className="font-semibold text-primary mb-4">Regulatory Moat</h4>
            <p className="text-gray-700 mb-4">
              Medical devices incorporating our LBM will require regulatory approval. Once approved,
              switching to a different AI provider would necessitate resubmission to regulatory bodies—a
              costly and time-consuming process that creates significant customer stickiness.
            </p>
            <p className="text-gray-700">
              Our progress with FDA pre-submission for our respiratory wearable demonstrates our ability to
              navigate complex regulatory landscapes successfully.
            </p>
          </div>
          <div>
            <h4 className="font-semibold text-primary mb-4">Collaborative Business Model</h4>
            <p className="text-gray-700 mb-4">
              Our model-as-a-service approach provides the LBM at no cost during R&D, tightly coupling
              the next generation of medical devices to our foundational technology from inception.
            </p>
            <p className="text-gray-700">
              This creates a win-win relationship where partners can focus on device development and clinical applications
              while leveraging our expertise in AI and biosignal processing.
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white p-8 rounded-xl shadow-md">
        <h3 className="text-2xl font-bold text-primary mb-6">Technology Differentiation</h3>
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white">
            <thead>
              <tr>
                <th className="py-3 px-4 bg-lightgray text-left text-primary">Capability</th>
                <th className="py-3 px-4 bg-lightgray text-center text-primary">Senti LBM</th>
                <th className="py-3 px-4 bg-lightgray text-center text-primary">Conventional Medical AI</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-200">
              <tr>
                <td className="py-3 px-4 font-medium">Cross-application generalization</td>
                <td className="py-3 px-4 text-center text-secondary font-medium">Yes</td>
                <td className="py-3 px-4 text-center text-gray-500">No</td>
              </tr>
              <tr>
                <td className="py-3 px-4 font-medium">Noise filtering in real-world environments</td>
                <td className="py-3 px-4 text-center text-secondary font-medium">Superior</td>
                <td className="py-3 px-4 text-center text-gray-500">Limited</td>
              </tr>
              <tr>
                <td className="py-3 px-4 font-medium">Biomarker extraction capability</td>
                <td className="py-3 px-4 text-center text-secondary font-medium">Multiple simultaneous</td>
                <td className="py-3 px-4 text-center text-gray-500">Single purpose</td>
              </tr>
              <tr>
                <td className="py-3 px-4 font-medium">Model scale</td>
                <td className="py-3 px-4 text-center text-secondary font-medium">Large scale (GPT-equivalent)</td>
                <td className="py-3 px-4 text-center text-gray-500">Small scale</td>
              </tr>
              <tr>
                <td className="py-3 px-4 font-medium">Explainability</td>
                <td className="py-3 px-4 text-center text-secondary font-medium">High (biomarker-based)</td>
                <td className="py-3 px-4 text-center text-gray-500">Limited</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default CompetitiveAdvantage;